module.exports = __webpack_public_path__ + "static/media/add_order_button.75570500.svg";